import { InternalFieldState, Mutator } from 'final-form';

export class StateMutator<FormValues> {
    setFieldValue: Mutator<FormValues> = ([fieldName, value], state, tools) => {
        tools.changeValue(state, fieldName, () => value);
    };
    setError: Mutator<FormValues> = ([fieldName, error]: [string, string], state) => {
        const { fields } = state;
        const touched = !!error;
        const field = fields[fieldName];
        field.data = { ...field.data };
        field.data.error = error;
        field.touched = touched;
    };
    setFieldState: Mutator<FormValues> = ([fieldName, dataProp, value]: [string, string, string], state, tools) => {
        if ((state.fields[fieldName] as InternalFieldState<string>)?.[dataProp as keyof InternalFieldState<string>] !== value) {
            tools.setIn(state.fields[fieldName], dataProp, value);
        } else {
            console.warn(`Skip state.fields[${fieldName}]?.data[${dataProp}] is ${value}`);
        }
    };
}
